import { Component, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ErrorDialogComponent } from "../components/error-dialog/error-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class DialogsService {

  constructor(private matDialog: MatDialog) { 
    
  }

  createDialog(dialog: ApplicationDialog): MatDialogRef<any, any> | undefined {
    return undefined;
  }
}

export enum ApplicationDialog {
  COMPLETE,
  ERROR
}
